import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@mui/material";
import { useTranslation } from "react-i18next";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FirstLoginDialog = ({ open, close }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={close}
      TransitionComponent={Transition}
    >
      <DialogTitle id="alert-dialog-title">
        {t('profile.welcomedialog.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('profile.welcomedialog.instructions1')}
        </DialogContentText>
        <br />
        <DialogContentText>
          {t('profile.welcomedialog.instructions2')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>OK</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FirstLoginDialog;
